import GoToPaymentTemplate from './template'

export default GoToPaymentTemplate
